var map = {
	"./calibri/Calibri-Bold-Italic.ttf": 180,
	"./calibri/Calibri-Bold.ttf": 181,
	"./calibri/Calibri-Italic.ttf": 182,
	"./calibri/Calibri-Light-Italic.ttf": 183,
	"./calibri/Calibri-Light.ttf": 184,
	"./calibri/Calibri-Regular.ttf": 185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;